module.exports = __webpack_public_path__ + "img/spins_3.5.b94d6a0c.png";